import React, { Fragment } from 'react';
import GradientPicker, {
  useColorPicker,
} from 'react-best-gradient-color-picker';
import pt from 'prop-types';

import { Field } from 'components/form';

import SwellColorPickerPreset from './color-picker-preset';

function isGradient(color) {
  return color.includes('-gradient(');
}

const tabs = Object.freeze([
  { value: 'solid', label: 'Solid' },
  { value: 'gradient', label: 'Gradient' },
  { value: 'css', label: 'CSS' },
]);

function SwellGradientColorPicker({
  color,
  presetColors,
  onChange,
  onApply,
  onCancel,
  onClose,
}) {
  // setGradient is created new each time, so it should not be in dependencies
  const { setSolid, setGradient } = useColorPicker(color, onChange);

  // React.useEffect(
  //   () => {
  //     setGradient(color);
  //   },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [color],
  // );

  const onCssChange = React.useCallback(
    (_, value) => {
      onChange(value);
    },
    [onChange],
  );

  const onClearClick = React.useCallback(() => {
    onChange('');
    // onApply();
    onClose();
  }, [onChange, onApply, onClose]);

  const [mode, setMode] = React.useState(() => {
    if (!color || isGradient(color)) {
      return 'gradient';
    }

    return 'solid';
  });

  const onTabChange = React.useCallback(
    (_, value) => {
      const isGradientValue = isGradient(color);

      switch (value) {
        case 'solid':
          setSolid(isGradientValue ? undefined : color);
          break;

        case 'gradient':
          setGradient(isGradientValue ? color : undefined);
          break;

        default:
          break;
      }

      setMode(value);
    },
    [color],
  );

  const onPresetClick = React.useCallback(
    (color) => {
      onChange(color);

      setMode(isGradient(color) ? 'gradient' : 'solid');
    },
    [onChange],
  );

  return (
    <React.Fragment>
      <div className="storefront-editor--color-scheme--picker-content">
        <Field
          type="radio"
          buttons={true}
          options={tabs}
          value={mode}
          onChange={onTabChange}
        />

        {(mode === 'solid' || mode === 'gradient') && (
          <Fragment>
            <GradientPicker
              value={color}
              width={242}
              height={242}
              hideEyeDrop
              hidePresets
              hideInputType
              hideColorGuide
              hideColorTypeBtns
              hideAdvancedSliders
              onChange={onChange}
            />

            <SwellColorPickerPreset
              presets={presetColors}
              onChange={onPresetClick}
            />
          </Fragment>
        )}

        {mode === 'css' && (
          <Field
            label="CSS code"
            type="textarea"
            placeholder="Paste the CSS code such as: linear-gradient (red 50%, blue 100%, green 23%)"
            rows={5}
            value={color}
            onChange={onCssChange}
          />
        )}
      </div>

      <div className="storefront-editor--color-scheme--picker--actions">
        <button
          className="button button-sm button-secondary"
          onClick={onCancel}
          type="button"
        >
          Cancel
        </button>

        <button
          className="button button-sm button-secondary"
          onClick={onClearClick}
          type="button"
        >
          Clear
        </button>

        {/* <button
          className="button button-sm button-default"
          onClick={onApply}
          type="button"
        >
          Apply
        </button> */}
      </div>
    </React.Fragment>
  );
}

SwellGradientColorPicker.propTypes = {
  color: pt.string,
  presetColors: pt.arrayOf(pt.string),
  onChange: pt.func.isRequired,
  onApply: pt.func.isRequired,
  onCancel: pt.func.isRequired,
  onClose: pt.func.isRequired,
};

export default React.memo(SwellGradientColorPicker);
